import { render, staticRenderFns } from "./editChainSupplier.vue?vue&type=template&id=61b406c4&scoped=true"
import script from "./editChainSupplier.vue?vue&type=script&lang=js"
export * from "./editChainSupplier.vue?vue&type=script&lang=js"
import style0 from "./editChainSupplier.vue?vue&type=style&index=0&id=61b406c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b406c4",
  null
  
)

export default component.exports